export enum PageTitle {
  CANDIDATES_PAGE = 'Candidates',
  SIGN_IN_PAGE = 'Sign in',
  FORGOT_PASSWORD = 'Forgot password',
  RESET_PASSWORD = 'Reset password',
  NOT_FOUND = 'Page not found',
  TEAMS_PAGE = 'My teams',
  EVALUATIONS = 'Evaluations',
  HAPPINESS = 'Happiness',
  TERMS = 'Terms of Service',
  PRIVACY = 'Privacy Policy',
}
